import type { SignalForm } from "@suse-o11y/signal/form";
import { useEffect } from "react";
import { flushSync } from "react-dom";

import { useHandler } from "~/tools/use-handler";

export function usePropagateFocusWhenInvalid<TForm extends SignalForm>(
	form: undefined | TForm,
	beforePropagate: VoidFunction,
): void {
	const beforePropagateStable = useHandler(beforePropagate);

	useEffect(() => {
		return form?.onFocusWhenInvalid(() => {
			// enforce the component to re-render
			flushSync(() => beforePropagateStable());

			// at this point the component with invalid fields should already expand further and register new focus handler
			form.focusFirstInvalid();
		});
	}, [form, beforePropagateStable]);
}
